// src/helpers/activeExportJobsStorage.ts
// Doc/ghi danh sach job export (goi in / anh QR) dang chay, luu trong localStorage theo tung
// jobId — cho phep nhieu ke hoach export song song deu duoc khoi phuc dung tien trinh sau khi F5
// hoac mo lai tab (xem GlobalJobProgress.tsx). Tach thanh module rieng de man Lap ke hoach
// (IssuancePlan/index.tsx) cung doc duoc de hien thi progress ngay trong cot trang thai, khong
// phai duy nhat popup noi goc man hinh moi biet job nao dang chay.

export interface StoredActiveExportJob {
  jobId: string;
  issuancePlanId?: number;
}

const ACTIVE_PRINT_EXPORT_JOB_KEY_PREFIX = 'lms_active_print_export_job_';
const ACTIVE_QR_IMAGE_EXPORT_JOB_KEY_PREFIX = 'lms_active_qr_image_export_job_';

const getStoredJobs = (prefix: string): StoredActiveExportJob[] => {
  const jobs: StoredActiveExportJob[] = [];

  Object.keys(localStorage)
    .filter((key) => key.startsWith(prefix))
    .forEach((key) => {
      try {
        const raw = localStorage.getItem(key);
        if (!raw) return;
        const parsed = raw.trim().startsWith('{') ? JSON.parse(raw) : { jobId: raw };
        if (parsed?.jobId) {
          jobs.push({
            jobId: parsed.jobId,
            issuancePlanId: parsed.issuancePlanId ? Number(parsed.issuancePlanId) : undefined,
          });
        }
      } catch {
        // Bo qua entry hong, khong lam crash restore cac job khac
      }
    });

  return jobs;
};

export const getStoredActivePrintExportJobs = (): StoredActiveExportJob[] =>
  getStoredJobs(ACTIVE_PRINT_EXPORT_JOB_KEY_PREFIX);

export const setStoredActivePrintExportJob = (jobId: string, issuancePlanId?: number) => {
  localStorage.setItem(`${ACTIVE_PRINT_EXPORT_JOB_KEY_PREFIX}${jobId}`, JSON.stringify({ jobId, issuancePlanId }));
};

export const clearStoredActivePrintExportJob = (jobId: string) => {
  localStorage.removeItem(`${ACTIVE_PRINT_EXPORT_JOB_KEY_PREFIX}${jobId}`);
};

// Cung shape luu tru voi cac ham tren, chi khac prefix key — dung rieng cho luong xuat anh QR.
export const getStoredActiveQrImageExportJobs = (): StoredActiveExportJob[] =>
  getStoredJobs(ACTIVE_QR_IMAGE_EXPORT_JOB_KEY_PREFIX);

export const setStoredActiveQrImageExportJob = (jobId: string, issuancePlanId?: number) => {
  localStorage.setItem(`${ACTIVE_QR_IMAGE_EXPORT_JOB_KEY_PREFIX}${jobId}`, JSON.stringify({ jobId, issuancePlanId }));
};

export const clearStoredActiveQrImageExportJob = (jobId: string) => {
  localStorage.removeItem(`${ACTIVE_QR_IMAGE_EXPORT_JOB_KEY_PREFIX}${jobId}`);
};

// Dong bo trang thai thu gon/mo rong cua popup noi (GlobalJobProgress.tsx) voi icon "eye" hien
// trong cot trang thai (PlanStatusColumn.tsx) — 2 component nay o 2 nhanh cay khac nhau (khong
// phai cha-con) nen phai dong bo qua window CustomEvent thay vi truyen props truc tiep.
export type JobPanelType = 'qr' | 'export' | 'qrImageExport';

// Phai khop dung format key dang dung trong GlobalJobProgress.tsx (VD: `export:${jobId}`).
export const buildJobPanelKey = (type: JobPanelType, jobId: string) => `${type}:${jobId}`;

// Phat tu PlanStatusColumn khi bam icon eye — yeu cau GlobalJobProgress dao trang thai thu gon/mo
// rong cua dung popup co key tuong ung. detail: { key: string }
export const JOB_PANEL_TOGGLE_REQUEST_EVENT = 'lms_job_panel_toggle_request';

// Phat tu GlobalJobProgress moi khi trang thai thu gon/mo rong cua bat ky popup nao thay doi, de
// PlanStatusColumn cap nhat lai icon eye cho dung. detail: { key: string; collapsed: boolean }
export const JOB_PANEL_STATE_EVENT = 'lms_job_panel_state';
